module.exports = __webpack_public_path__ + "img/welcome-bg2.84b51c31.png";